import { AppBar, Box, IconButton, Link, Toolbar, Typography } from '@mui/material';
import { Refresh } from '@mui/icons-material';
import type React from 'react';
import AllianzLogo from './AllianzLogo';

interface HeaderProps {
  onStartOver: () => void;
}

const TITLE = 'AGILE Rates Centre';

const startOverButtonStyles = {
  color: 'white',
  textDecoration: 'none',
  cursor: 'pointer',
  border: 'none',
  background: 'none',
  fontSize: { xs: '0.875rem', sm: '1rem' },
  fontFamily: 'inherit',
  '&:hover': {
    textDecoration: 'underline',
  },
};

const Header: React.FC<HeaderProps> = ({ onStartOver }) => {
  return (
    <AppBar position="static" color="primary" elevation={0}>
      <Toolbar sx={{ justifyContent: 'space-between', py: 1, flexWrap: 'wrap', gap: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
          <AllianzLogo />
          <Typography
            variant="h6"
            component="div"
            sx={{
              fontWeight: 400,
              fontSize: { xs: '0.875rem', sm: '1.2rem' },
              display: { xs: 'none', sm: 'block' },
            }}
          >
            {TITLE}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <IconButton
            onClick={onStartOver}
            sx={{ color: 'white', p: 1 }}
            size="small"
          >
            <Refresh />
          </IconButton>
          <Link
            component="button"
            onClick={onStartOver}
            sx={startOverButtonStyles}
          >
            Start over
          </Link>
        </Box>
      </Toolbar>
      {/* Mobile title */}
      <Box sx={{ display: { xs: 'block', sm: 'none' }, px: 2, pb: 1 }}>
        <Typography
          variant="body2"
          sx={{
            color: 'white',
            fontSize: '0.875rem',
            textAlign: 'center',
          }}
        >
          {TITLE}
        </Typography>
      </Box>
    </AppBar>
  );
};

export default Header;
